var map = {
	"./croaktest.ts": "./src/wl-core/config/stages/croaktest.ts",
	"./development-js.ts": "./src/wl-core/config/stages/development-js.ts",
	"./development-local.ts": "./src/wl-core/config/stages/development-local.ts",
	"./development-ssl.ts": "./src/wl-core/config/stages/development-ssl.ts",
	"./ioe.ts": "./src/wl-core/config/stages/ioe.ts",
	"./lego-ssl.ts": "./src/wl-core/config/stages/lego-ssl.ts",
	"./production-commissioned.ts": "./src/wl-core/config/stages/production-commissioned.ts",
	"./production-connect.ts": "./src/wl-core/config/stages/production-connect.ts",
	"./production-itz.ts": "./src/wl-core/config/stages/production-itz.ts",
	"./production-lausanne.ts": "./src/wl-core/config/stages/production-lausanne.ts",
	"./production-nickv.ts": "./src/wl-core/config/stages/production-nickv.ts",
	"./production-welibrary.ts": "./src/wl-core/config/stages/production-welibrary.ts",
	"./staging-commissioned.ts": "./src/wl-core/config/stages/staging-commissioned.ts",
	"./staging-welibrary.ts": "./src/wl-core/config/stages/staging-welibrary.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/wl-core/config/stages sync recursive ^\\.\\/.*\\.ts$";